import { Injectable } from '@angular/core';
import { marked } from 'marked';
import * as DOMPurify from 'dompurify';
import hljs from 'highlight.js';
import { Config } from 'dompurify';

@Injectable({
  providedIn: 'root'
})
export class MarkdownService {
  private purifier = typeof window !== 'undefined'
    ? DOMPurify
    : { sanitize: (x: string) => x } as Pick<typeof DOMPurify, 'sanitize'>;
  constructor() {
    marked.setOptions({
      gfm: true,
      breaks: true,
    });


    const renderer = new marked.Renderer();

    renderer.link = ({ href, title, text }) => {
      const h = href ?? '';
      const t = title ? ` title="${title}"` : '';
      const label = text ?? h;
      return `<a href="${h}"${t} target="_blank" rel="noopener noreferrer">${label}</a>`;
    };

    marked.use({ renderer });
  }


  toHtml(md: string): string {
    const dirty = marked.parse(md ?? '') as string;

    const cfg: Config = {
      ALLOWED_TAGS: [
        'h1','h2','h3','h4','h5','h6','p','br','blockquote','code','pre','strong','em',
        'ul','ol','li','hr','a','img','span','table','thead','tbody','tr','th','td'
      ],
      ALLOWED_ATTR: ['href','title','target','rel','src','alt','class'],
      // make the return type plain string to satisfy TS
      RETURN_TRUSTED_TYPE: false,
    };

    return DOMPurify.sanitize(dirty, cfg);
  }
}
